import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import env from '@config/env';

export interface Nazione {
  sigla: string;
  nome: string;
}

export interface Provincia {
  sigla: string;
  nome: string;
}

export interface Comune {
  codice: string;
  nome: string;
  cap: string;
}

export interface Cap {
  cap: string;
}

const apiComuni = createApi({
  reducerPath: 'apiComuni',
  baseQuery: fetchBaseQuery({
    baseUrl: env.APICOMUNI_URL,
    headers: {
      'x-api-key': env.APICOMUNI_API_KEY,
    },
  }),
  endpoints: (builder) => ({
    getNations: builder.query<Nazione[], void>({
      query: () => ({
        url: '/nazioni',
      }),
    }),
    getProvinces: builder.query<Provincia[], void>({
      query: () => ({
        url: '/province',
      }),
    }),
    getCities: builder.query<Comune[], string>({
      query: (provinceCode) => ({
        url: '/comuni',
        params: { siglaProvincia: provinceCode },
      }),
    }),
    getZips: builder.query<Cap[], string>({
      query: (city) => ({
        url: '/cap',
        params: { nomeCitta: city },
      }),
    }),
  }),
});

export default apiComuni;

export const {
  useGetProvincesQuery,
  useGetCitiesQuery,
  useGetNationsQuery,
  useGetZipsQuery,
} = apiComuni;
